var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"preview",staticClass:"cr-preview",class:{ round: _vm.round },style:(_vm.blockStyle)},[_c('img',{staticClass:"cr-image",style:(_vm.crImage),attrs:{"src":_vm.imageSrc}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96f637aa","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-components/~/crop-image/src/crop-image-preview.vue
// module id = 735
// module chunks = 0